<template>
    <div class="mt-4" v-if="currentJourney">
        <div class="w-100">
            <div>
                <div class="container">
                    <div class="row">
                        <div class="col-12 d-flex mb-3 p-0">
                            <div class="col-6">
                                <h2 class="pricing-title">Pricing breakdown</h2>
                            </div>
                            <div class="col-6">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <p>X Close</p>
                                </button>
                            </div>
                        </div>
                        <div class="col-12 ">
                            <p class="pricing-breakdown-title">The price displayed in your journey plan is an <strong>estimate only</strong></p>
                            <div v-for="(price, index) in breakdownList"
                                :key="index"
                                >
                                <div class="row pt-3 pb-3 mt-n1 pricing-breakdown-information">
                                    <div class="col-8">
                                        <p >{{ price.description }}</p>
                                    </div>
                                    <div class="col-4 d-flex justify-content-end">
                                        <p>{{ price.cost }} </p>
                                    </div>
                                </div>
                                <hr>
                            </div>
                            <div class="row pt-3 pb-3 mt-n1 pricing-breakdown-information">
                                <div class="col-8">
                                    <p>Total price</p>
                                </div>
                                <div class="col-4 d-flex justify-content-end">
                                    <p> {{currentJourney.cost}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                 </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'

export default {
    data() {
        return {
            showingJourneyType: 'depart',
            showingReturnType: false,
        }
    },
    props: {
        journeyType: {
            type: String,
            default: 'depart',
        },
        showingReturn: {
            default: true,
            type: Boolean,
        },
    },
    computed: {
        ...mapState([
            'currentJourney',
            'user',
        ]),
        ...mapGetters([
            'getIconNamesByStage',
        ]),
        icons() {
            return this.getIconNamesByStage(this.showingJourneyType)
        },
        breakdownList() {
            return this.currentJourney.pricing_breakdown
        },
    },
}
</script>
<style lang="scss">

    .save-button-section{border-radius: 0px 0px 9px 9px;}
    .pricing-title{
        font-size: 1.25em;
    }

</style>
